// extracted by mini-css-extract-plugin
module.exports = {"container":"TableHighlight_container__OsVy8","match":"TableHighlight_match__3hLEM"};